import { values } from './enums'

const _enum = {
  BankDetail: 1 << 0,
  CompanyDetail: 1 << 1,
  BankStatus: 1 << 2,
  CompanyStatus: 1 << 3,
  CompanyType: 1 << 4,
  CompanyDealsWithBank: 1 << 5,
  Licenses: 1 << 6,
  Addresses: 1 << 7,
  Contacts: 1 << 8,
  InstitutionGroups: 1 << 9,
  Branches: 1 << 10,
  RealEstates: 1 << 11,
  IndividualsInCharge: 1 << 12,
  AssociatedPersons: 1 << 13,
  AssociatedToInstitutions: 1 << 14,
  StatusHistory: 1 << 15,
  CapitalOperations: 1 << 16,
  BankCapital: 1 << 17,
  BankAccountNumbers: 1 << 18,
  Blacklists: 1 << 19,
  ChangeHistory: 1 << 20,
  BankDealsHistory: 1 << 21
}

export const institutionPermissionTypes = {
  enumName: 'InstitutionPermissionTypes',
  enum: _enum,
  values: values(_enum),
  bankPermissions: ['BankDetail', 'BankStatus', 'CapitalOperations', 'BankCapital', 'BankAccountNumbers'],
  companyPermissions: ['CompanyDetail', 'CompanyStatus', 'CompanyType', 'CompanyDealsWithBank'],
  sharedPermissions: ['Licenses', 'Addresses', 'Contacts', 'InstitutionGroups', 'Branches',
    'RealEstates', 'IndividualsInCharge', 'AssociatedPersons', 'AssociatedToInstitutions', 'StatusHistory',
    'Blacklists', 'ChangeHistory', 'BankDealsHistory']
}



// WEBPACK FOOTER //
// ./src/enums/institutionPermissionTypes.js